import { map } from 'lodash';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

export default function usePaymentMethods() {
  const paymentMethods = {};
  const {
    user: {
      attributes: { availablePaymentMethods }
    }
  } = useSelector((state) => state.auth);

  map(availablePaymentMethods, (paymentMethod) => {
    paymentMethods[paymentMethod.key] = {
      ...paymentMethod,
      translation: paymentMethod.paymentTitle
    };
  });

  return paymentMethods;
}

export const GetActivePaymenthMethods = () => {
  const intl = useIntl();
  const activePaymentMethods = {
    OTHER: {
      id: 0,
      translation: intl.formatMessage({ id: 'controlpanel.global.other' }),
      paymentTitle: intl.formatMessage({ id: 'controlpanel.global.other' }),
      csvOrders: false,
      active: false,
      commissionAmount: 0,
      csv: false,
      imageUrl: '',
      key: 'OTHER',
      moneybox: false,
      name: intl.formatMessage({ id: 'controlpanel.global.other' })
    }
  };
  const {
    user: {
      attributes: { availablePaymentMethods }
    }
  } = useSelector((state) => state.auth);

  map(availablePaymentMethods, (paymentMethod) => {
    if (paymentMethod.active === true) {
      activePaymentMethods[paymentMethod.key] = {
        ...paymentMethod,
        translation: paymentMethod.paymentTitle
      };
    }
  });

  return activePaymentMethods;
};

export const GetSelectStructure = () => {
  const paymentMethods = GetActivePaymenthMethods();
  const selectStructure = [];

  map(paymentMethods, (data, paymentMethod) => {
    selectStructure.push({
      value: paymentMethod,
      label: data.translation
    });
  });

  return selectStructure;
};
